module.exports = __webpack_public_path__ + "img/user-blank-photo.e8120db0.jpg";